import React from 'react';
import { connect } from 'react-redux';
import * as actions from 'actions/editor/commentary';
import { getCommentsCount } from 'selectors/commentary';

const CommentaryHeader = ({ count, hideCommentary }) => (
  <div className="Commentary-header">
    <div className="Commentary-commentCount">
      <span
        className="Commentary-title"
        children={t('lessons.editor.collaboration.comments', { count })}
      />
      <div className="Commentary-title--secondary">
        {t('lessons.editor.collaboration.subtitle')}
      </div>
    </div>
    <button
      type="button"
      className="Commentary-closeButton"
      onClick={hideCommentary}
      children={t('lessons.editor.collaboration.hide')}
    />
  </div>
);

const mapStateToProps = ({ editor }) => ({
  count: getCommentsCount(editor.commentary),
});

const mapDispatchToProps = {
  hideCommentary: actions.hideCommentary,
};

export default connect(mapStateToProps, mapDispatchToProps)(CommentaryHeader);
